// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.volume{display:flex;flex-direction:column;height:100%}`, "",{"version":3,"sources":["webpack://./report/view/visualizations/volume/volumeViz.scss"],"names":[],"mappings":"AAAA,QACE,YAAA,CACA,qBAAA,CACA,WAAA","sourcesContent":[".volume {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
